import { Identifier } from '@app/utils/common';
import { FormMapping } from '@app/utils/form-mapping/decorators/form-mapping';
import { Local, StringInput } from '@app/utils/form-mapping/helpers/default-attributes';
import { FormMappingModel } from '@app/utils/form-mapping/models/form-mapping-model';

@FormMapping()
export class PhoneNumberFormModel extends FormMappingModel {
  @StringInput({
    defaultValue: '',
  })
  internal: string;

  @Local
  screenNumberId: Identifier;
}
